import React from 'react'
import styled from 'styled-components/native'
import { atlTheme } from '../../atlTheme'
import { ATLAtomIcon, ATLTextBody, TextAlignmentEnum } from '@appsimples/atlantica-react-native'
import { icons } from '../../constants/searchAssets'
import { DashboardCustomDropdownItem } from './DashboardCustomDropdownList'

interface DashboardCustomDropdownProps {
  handleClick: () => void
  selectedItem: DashboardCustomDropdownItem
}

const DropdownContainer = styled.TouchableHighlight`
  height: 40px;
  width: 100%;
  background: ${atlTheme.ColorSurface};
  flex-direction: row;
  display: flex;
`
const DropdownInputContainer = styled.View`
  width: 90%;
`
const DropdownExpanderContainer = styled.View`
  margin-top: ${atlTheme.SpacingAtomic}px;
`

export const DashboardCustomDropdown: React.FC<DashboardCustomDropdownProps> = ({ handleClick, selectedItem }) => {
  return (
    <DropdownContainer onPress={handleClick} underlayColor={'transparent'}>
      <>
        <DropdownInputContainer>
          <ATLTextBody
            labelBaseProps={{
              multilineLimit: 1,
              textColor: atlTheme.ColorBrand1Default,
              textAlign: TextAlignmentEnum.center,
            }}
          >
            {selectedItem?.text?.toUpperCase()}
          </ATLTextBody>
        </DropdownInputContainer>
        <DropdownExpanderContainer>
          <ATLAtomIcon source={icons.arrowDown} />
        </DropdownExpanderContainer>
      </>
    </DropdownContainer>
  )
}
